(() => {
  if (customElements.get('vendor-list-collapse')) return;
  customElements.define('vendor-list-collapse', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-vendor-list]');
      this.button = this.querySelector('button');
      if (!this.list || !this.button) return;
      this.expanded = false;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.toggle = () => {
        this.expanded = !this.expanded;
        this.update();
        // Keep the control in view when collapsing a long list.
        if (!this.expanded) requestAnimationFrame(() => {
          if (this.isConnected) this.button.scrollIntoView({ block: 'center', behavior: 'instant' });
        });
      };
      this.button.addEventListener('click', this.toggle);
      this.media = matchMedia('(max-width: 767px)');
      this.media.addEventListener('change', this.schedule);
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.list);
      // The vendor list is populated asynchronously by vendor-collection-links.js.
      this.mutations = new MutationObserver(this.schedule);
      this.mutations.observe(this.list, { childList: true, subtree: true });
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.update();
    }
    update() {
      const items = Array.from(this.list.children);
      items.forEach(item => { item.hidden = false; item.classList.remove('is-preview-last'); });
      const mobile = this.media.matches;
      const lineHeight = parseFloat(getComputedStyle(this.list).lineHeight) || 28;
      const top = this.list.getBoundingClientRect().top;
      const overflow = mobile ? items.filter(item => item.getBoundingClientRect().bottom > top + lineHeight * 3 + 1) : [];
      if (mobile && !this.expanded) overflow.forEach(item => { item.hidden = true; });
      if (mobile && !this.expanded && overflow.length) items.filter(item => !item.hidden).at(-1)?.classList.add('is-preview-last');
      this.button.hidden = !mobile || overflow.length === 0;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resize?.disconnect();
      this.mutations?.disconnect();
      this.media?.removeEventListener('change', this.schedule);
      this.button?.removeEventListener('click', this.toggle);
    }
  });
})();
